import {useStyles} from '../../hooks/styles';
import {DeviceSize} from '../../theme/helpers';

export default () =>
  useStyles(({theme, mediaOnly}) => ({
    card: mediaOnly(DeviceSize.desktop, {flexDirection: 'row'}, {flexDirection: 'column'}),
    imageWrapper: {
      ...mediaOnly(DeviceSize.desktop, {marginRight: 40}),
      justifyContent: 'flex-start',
    },
    image: mediaOnly(DeviceSize.desktop, {width: 160, height: 100}, {width: 260, height: 165, marginBottom: 12}),
    contentWrapper: {
      justifyContent: 'center',
    },
    contactsItem: {
      ...mediaOnly(DeviceSize.desktop, {marginTop: 10, marginBottom: 10}, {marginBottom: 10}),
      flexDirection: 'row',
      alignItems: 'center',
    },
    contactsItemIcon: {
      flexShrink: 0,
      flexGrow: 0,
      marginRight: 13,
      width: 24,
      height: 24,
      alignItems: 'center',
      color: theme.color.primaryColor,
    },
    contactsItemValue: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.h6Light),
      overflow: 'hidden',
    },
  }));
